import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=4ad19004"
import script from "./RichText.vue?vue&type=script&lang=ts"
export * from "./RichText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports